import { useMemo, useState } from 'react'
import { __ } from '@wordpress/i18n/build'
import Button from '../Common/Button';
import Source from '../Common/Source';
import AddSourceModal from './AddSourceModal';

const CustomizerSourcesModal = ( props ) => {

    const [ choosedSources, setChoosedSources ] = useState( props.selectedSources );
    const [ addSourcesModalActive, setAddSourcesModalActive ] = useState( false );

    const selectSourceClick = ( sourceId ) => {
        const sSources = Object.values( choosedSources );
        if( !sSources.includes( sourceId ) ){
            sSources.push(sourceId)
        }else{
            sSources.splice( sSources.indexOf( sourceId ), 1 );
        }
        setChoosedSources(sSources)
    }

    const connectFacebookActiveMemo = useMemo( () => {
        if( props.fbModal.connectFacebookActive === true ){
            setAddSourcesModalActive( true )
            return true;
        }
        return false;
    },[ props.fbModal ]);


    return (
        <>
        {
            !addSourcesModalActive &&
            <div className='sb-feedsources-modal sb-fs'>
                <div className='sb-feedsources-modal-content'>
                    <div className='sb-feedsources-modal-heading sb-fs'>
                        <h4 className='sb-h4'>{ __( 'Add Sources', 'sb-customizer' ) }</h4>
                        <span className='sb-text-small sb-dark2-text'>{ __( 'Select one or more sources you would like to add', 'sb-customizer' ) }</span>
                    </div>
                    <div className='sb-feedsources-modal-list sb-fs'>
                        <Button
                            text={ __( 'Add New', 'sb-customizer' ) }
                            icon='plus'
                            customClass='sb-addnew-source'
                            boxshadow={ false }
                            size='small'
                            iconSize='14'
                            onClick={ () => {
                                setAddSourcesModalActive( true )
                            } }
                        />
                    {
                        props.sources.sourcesList.map( ( source, sourceInd ) => {
                            return (
                                <Source
                                    key={ sourceInd }
                                    provider={ source.provider }
                                    checkbox={true}
                                    isChecked={ choosedSources.includes( source.account_id ) }
                                    name={ source.name }
                                    onClick={ () => {
                                        selectSourceClick( source.account_id );
                                    }}
                                />
                            )
                        } )
                    }
                    </div>

                    <div className='sb-feedsources-modal-btns sb-fs'>
                        <Button
                                size='medium'
                                type='secondary'
                                onClick={ () => {
                                    props?.onCancel &&
                                        props.onCancel()
                                }}
                                text={ __( 'Cancel', 'sb-customizer' ) }
                            />
                            <Button
                                icon='plus'
                                iconSize='12'
                                size='medium'
                                type='primary'
                                onClick={ () => {
                                    props.onUpdateSources( choosedSources )
                                } }
                                text={ __( 'Add', 'sb-customizer' ) }
                            />
                    </div>
                </div>
            </div>
        }
        {
            addSourcesModalActive &&
            <AddSourceModal
                openDialog={ () => {
                    setAddSourcesModalActive( true )
                } }
                onCancel={ () => {
                    setAddSourcesModalActive( false )
                } }
            />
        }
    </>

    )
}


export default CustomizerSourcesModal;